import React from 'react'

const BButton = ({className, loading, focused, children, yellow, red, green, white, ghost, bordered, disabled, ...props}) => (
  <button
    type="primary"
    className={(className ?? '') + ' bButton' + (yellow ? ' yellow' : '') + (red ? ' red' : '') + (green ? ' green' : '') + (white ? ' white' : '') + (ghost ? ' ghost' : '') + (bordered ? ' bordered' : '') + (focused ? ' focused' : '')}
    disabled={disabled ?? loading}
    {...props}
  >
    {children}
  </button>
)

export default BButton
